import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../api/api";

const ProtectedIrrigationRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [redirect, setRedirect] = useState(null);

  useEffect(() => {
    async function checkAccess() {
      try {
        // Check authentication
        const me = await api.get("/auth/me");

        if (!me.data) {
          setRedirect("/login");
          return;
        }

        // Check SWIP completion
        const status = await api.get("/swip/swip-status");

        if (!status.data.hasIrrigation) {
          setRedirect("/swip");
        } else {
          setAuthorized(true);
        }

      } catch (err) {
        setRedirect("/login");
      } finally {
        setLoading(false);
      }
    }

    checkAccess();
  }, []);

  if (loading) return null;

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  if (!authorized) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedIrrigationRoute;
